import { ReactNode } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';
import { showPageHeaderWrapperSx } from '../../pageLayoutSx';
import { topButtonsSx } from '../../ShowPageLayout/topButtonsSx';

export type FormPageTitleVariant = 'h1' | 'h2' | 'h4';
type FormPageTitleColor = 'brand' | 'primary' | 'textPrimary';

interface FormPageTitleProps {
  title?: string;
  titleActions?: ReactNode;
  variant: FormPageTitleVariant;
  color: FormPageTitleColor;
  containerSx?: SystemStyleObject<Theme>;
  titleSx?: SystemStyleObject<Theme>;
}

const FormPageTitle = ({ title, titleActions, variant, color, containerSx, titleSx }: FormPageTitleProps) => {
  if (!title && !titleActions) return null;

  return (
    <Box sx={{ ...showPageHeaderWrapperSx, ...(containerSx || {}) }}>
      {title ? (
        <Typography variant={variant} component={variant} color={color} sx={titleSx}>
          {title}
        </Typography>
      ) : null}
      {titleActions ? (
        <Stack className="top-btns" sx={topButtonsSx}>
          {titleActions}
        </Stack>
      ) : null}
    </Box>
  );
};

export default FormPageTitle;
